import { render, staticRenderFns } from "./edit-group-document.vue?vue&type=template&id=8b5ef3a6&scoped=true&"
import script from "./edit-group-document.vue?vue&type=script&lang=js&"
export * from "./edit-group-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5ef3a6",
  null
  
)

export default component.exports